import { useGetPackageOffersAndFlightOptions } from '../useGetPackageOffersAndFlightOptions';

const usePackageOffers = () => {
  const { paginatedData, error, isValidSearchQuery, searchQuery } =
    useGetPackageOffersAndFlightOptions();

  const data = paginatedData?.[0];
  const loading = !data && !error && !!isValidSearchQuery;

  return {
    searchQuery,
    isPreSearch: !isValidSearchQuery,
    error,
    loading,
    availability: data?.availability,
    packageOffers: data?.packageOffers,
    holidaysPointsTiers: data?.qffPointTiers,
  };
};

export default usePackageOffers;
